import React, { useEffect, useState } from 'react'

import MonthlyDateSelect from '../../../../components/AppInput/MonthlyDateSelect';
import moment from 'moment';
import CalculateHours from '../../../../components/CalculateHours';
import CalculateTotalWorkingHours from '../../../../components/CalculateTotalWorkingHours';
import essAttendanceServices from '../essAttendanceServices';
import { useEssAppData } from '../../../../context/AppESSDataContext';

function ESSPunchList() {
    const [punchList,setPunchList] = useState(null);
    const [filter,setFilter] = useState(null);
    const {employeeDD,getDDDataById} = useEssAppData();

    const getPunchList = () =>{
        essAttendanceServices.getPunchList(filter).then(res=>{
            setPunchList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getPunchList();
    },[filter])

    return (
        <div className='row'>
            <div className='col-md-12'>
                <MonthlyDateSelect filter={filter} setFilter={setFilter} />
            </div>
            <div className='col-md-12'>
                <table className='table table-striped'>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>In Time</th>
                            <th>Out Time</th>
                            <th>Hours</th>
                        </tr>
                    </thead>
                    <tbody>
                        {punchList && punchList.map((punch)=>
                            <tr key={punch.id} className={punch.updatedBy !== null ? 'table-danger':""}>
                                <td>{moment(punch.inTime).format("D, MMM, dddd")}</td>
                                <td>{moment(punch.inTime).format("LLL")}</td>
                                <td>{punch.outTime !== null ?
                                        moment(punch.outTime).format("LLL")
                                        :
                                        "--------"
                                    }
                                </td>
                                <td> 
                                    {punch.outTime !== null ?
                                        <CalculateHours inTime={punch.inTime} outTime={punch.outTime} />
                                        :
                                        <div>--------</div>
                                    }
                                    {punch.updatedBy != null && 
                                        <div>
                                            <span className='fw-bold'>Updated By :</span> {getDDDataById(employeeDD,punch.updatedBy).label}
                                        </div>
                                    }
                                </td>
                            </tr>
                        )}
                    </tbody>
                    {punchList &&
                        <tfoot>
                            <tr>
                                <td colSpan={4}>
                                    <CalculateTotalWorkingHours punchList={punchList} />
                                </td>
                            </tr>
                        </tfoot>
                    }
                </table>
                
            </div>
        </div>
    )
}

export default ESSPunchList